/* istanbul ignore file */
import React, { ReactElement } from "react";
import { DefaultHoofdstuk } from "../../../.generated/rapportage/rapportagetypes";
import { Chapter } from "../components/Chapter";
import Heading, { HeadingLevel } from "../components/Heading";
import { Paragraph } from "../components/Paragraph";

type DefaultHoofdstukProps = {
  defaultHoofdstuk?: DefaultHoofdstuk | null;
  titel?: string | null;
  level?: HeadingLevel;
  withMarkdown?: boolean;
};

const DefaultHoofdstukChapter = ({
  defaultHoofdstuk,
  titel,
  level = 2,
  withMarkdown = false,
}: DefaultHoofdstukProps): ReactElement => {
  return (
    <Chapter>
      {titel && <Heading text={titel} level={level} />}
      {defaultHoofdstuk?.paragrafen &&
        Object.entries(defaultHoofdstuk.paragrafen).map(([key, paragraaf]) => (
          <Paragraph key={key} withMarkdown={withMarkdown}>{paragraaf.inhoud}</Paragraph>
        ))}
    </Chapter>
  );
};

export default DefaultHoofdstukChapter;
